module.exports = __webpack_public_path__ + "media/icons/heart_blue-62e15fe6.svg";